import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { Toolbar, Typography, Tooltip } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import DesactivateUser from "../user/DesactivateUser";
import ModalEditUser from "../user/ModalEditUser";
import ModalProviderUser from "../user/ModalProviderUser";

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    backgroundColor: "#F7FAFF",
  },
  highlight: {
    color: "white !important",
    backgroundColor: "#f2f2f2",
  },

  title: {
    flex: "1 1 100%",
    fontWeight: 900,
    color: theme.palette.primary.dark,
  },
}));

const EmployeeTableToolbar = ({
  usersSelected,
  title,
  label,
  type,
  isUserDeleted,
  loadUsers,
}) => {
  const classes = useToolbarStyles();
  const [openDeleteScreen, setOpenDeleteScreen] = React.useState(false);
  const [openEditScreen, setOpenEditScreen] = React.useState(false);

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: usersSelected?.length > 0,
      })}
    >
      {usersSelected.length > 0 ? (
        <Typography className={classes.title} variant="h6" component={"span"}>
          {usersSelected.length} {label}
        </Typography>
      ) : (
        <Typography
          className={classes.title}
          color="primary"
          variant="h5"
          id="tableTitle"
          component={"span"}
        >
          {title}
        </Typography>
      )}

      {usersSelected.length === 1 && (
        <Tooltip title="Editar">
          <IconButton aria-label="edit" onClick={() => setOpenEditScreen(true)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
      )}

      {usersSelected.length > 0 && (
        <Tooltip title="Eliminar">
          <IconButton
            onClick={() => setOpenDeleteScreen(true)}
            aria-label="delete"
          >
            <DeleteIcon> </DeleteIcon>
          </IconButton>
        </Tooltip>
      )}

      {openDeleteScreen && (
        <DesactivateUser
          onClose={() => setOpenDeleteScreen(false)}
          userSelected={usersSelected}
          type={type}
          isUserDeleted={isUserDeleted}
        />
      )}

      {openEditScreen && type === "employee" && (
        <ModalEditUser
          onClose={() => setOpenEditScreen(false)}
          userSelected={usersSelected}
          type={type}
          loadUsers={loadUsers}
        />
      )}

      {openEditScreen && type === "provider" && (
        <ModalProviderUser
          onClose={() => setOpenEditScreen(false)}
          userSelected={usersSelected}
          type={type}
          loadUsers={loadUsers}
        />
      )}
    </Toolbar>
  );
};

export default EmployeeTableToolbar;
